import {
  styled,
  Typography,
  InputLabel as BaseInputLabel,
} from '@material-ui/core'
import FieldLabel from '../../FieldLabel'

const DIALOG_FIELD_WRAPPER_WIDTH_SMALL = 110
const DIALOG_FIELD_WRAPPER_WIDTH_NORMAL = 230

export const FormWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  margin: theme.spacing(1, 1, 0, 2),
}))

export const DialogFieldWrapper = styled('div')(
  ({ small }: { small?: boolean }) => ({
    width: small
      ? DIALOG_FIELD_WRAPPER_WIDTH_SMALL
      : DIALOG_FIELD_WRAPPER_WIDTH_NORMAL,
  })
)

export const DialogRowWrapper = styled(DialogFieldWrapper)(({ theme }) => ({
  marginTop: theme.spacing(2.7),
}))

export const SectionWrapper = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
}))

export const SectionTitle = styled(Typography)({
  fontSize: 16,
  fontWeight: 700,
})

export const RowOfTextfieldsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(2.7),
  '& > div': {
    '&:last-child': {
      marginLeft: theme.spacing(2),
    },
  },
}))

export const Wrapper = styled('div')({})

export const CheckboxWrapper = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}))

export const Label = styled(FieldLabel)({
  fontSize: 12,
  lineHeight: 1,
})

export const InputLabel = styled(BaseInputLabel)(({ theme }) => ({
  marginBottom: theme.spacing(0.6),
  whiteSpace: 'nowrap',
}))
